import React, {Component} from 'react';
import { TableHeaderColumn } from "react-bootstrap-table";
import {RenderMoneda, RenderDateTime} from "../../../Utils/renderField/renderTableField";
import {Monedas} from "../../../../../utility/constants";
import {withRouter} from 'react-router';
import {standardActions} from "../../../Utils/Grid/StandardActions";

import CardSimple from '../../../Utils/Cards/cardSimple';
import Modal from 'react-responsive-modal';
import Swal from 'sweetalert2';

import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';

import MiCaja from './miCaja';
import EgresoForm from './egresoForm';
import RetiroForm from './retiroForm';
import HistorialCaja from './historialCaja';
import HistorialLiquidaciones from '../../liquidaciones/liquidacionesGrid/historial';
import RecibosCaja from '../../liquidaciones/liquidacionesGrid/recibos_caja';
import EstadoPeriodo from './periodoCaja';
import CerrarEstadoPeriodo from './cerrarPeriodoCaja';
import HistorialDetalle from '../../liquidaciones/liquidacionesGrid/historialDetalle'
import iconoImprimir from '../../../../../../assets/img/icons/imprimir.png';
import {LiquidacionesGrid} from '../../liquidaciones';


class DetalleCaja extends Component{
    state = {
        open_modal:false,
        open_modal_retiro:false,
        openModalPago: false,
        transaccion_sel: null,
        modalHistory:false,
        modalHistorialLiquidaciones: false,
        openModalReciboDetalle: false,
        open_modal_cierre: false,
        openDetallePago: false,
        periodo: null
    }
    handleSubmit = (values) => {
        if(values.egreso_tipo == "true"){
            values.caja = undefined;
        } else {
            values.banco = undefined;
        }
        this.props.movimiento(values, this.props.match.params.id);
        this.setOpenModal(false);
    }
    handleSubmitRetiro = (values) => {
        this.props.retiroDeCaja(values, this.props.match.params.id);
        this.setOpenModalRetiro(false);
    }
    setOpenModal = (val)=>{
        this.setState({open_modal:val})
        if (val===true)
            this.props.listar()
    }
    setOpenModalRetiro = (val)=>{
        this.setState({open_modal_retiro:val})
        if (val===true)
            this.props.selectEmpresas()
    }
    setOpenModalHistory = (val, row)=>{
        this.setState({modalHistory:val})
        if (val === true)
            this.props.estadoPeriodo(row.id)
            // this.setState({periodo:row})
    }

    setOpenModalHistorilLiquidaciones = (val, row)=>{
        this.setState({modalHistorialLiquidaciones: val})
        if (val === true)
        this.props.getLiquidacionEP(row.id)
    }

    setOpenModalReciboDetalle = (val, row)=>{
        this.setState({openModalReciboDetalle: val})
        if (val === true)
        this.props.getReciboCajaDetalleEP(row.id)
    }

    componentDidMount(){
        let id = this.props.match.params.id;
        let {leer, listPCaja, estadoMiCaja } = this.props
        // lee la informaciond el estado de la caja del ultimo periodo
        leer(id);
        //lista los traslados que etan pendientes de confirmar en ambas vias
        listPCaja(id);
        //obtiene el estado de cuenta de la caja en el ultimo periodo
        estadoMiCaja(id);
    }
    componentDidUpdate(prevProps){
        if (this.props.match.params.id != prevProps.match.params.id){
            let id = this.props.match.params.id;
            let {leer, listPCaja, estadoMiCaja } = this.props
            // lee la informaciond el estado de la caja del ultimo periodo
            leer(id);
            //lista los traslados que etan pendientes de confirmar en ambas vias
            listPCaja(id);
            //obtiene el estado de cuenta de la caja en el ultimo periodo
            estadoMiCaja(id);
        }
    }
    setOpenModalCierre = (val)=>{
        this.setState({open_modal_cierre: val})
        if (val === true)
            this.props.cerrarEstadoPeriodo()
    }
    cerrarperiodo = () =>{
        this.props.cierredecaja(this.props.match.params.id)
    }

    getsimbolo =(valor)=>{
        let simbolo =''
        Monedas.forEach((item,index)=>{
            if (item.value === valor){
                simbolo = item.simbolo
            }
        })
        return simbolo + '. '
    }

    abrirModalAlerta = (id, row) => {
        this.setState({verAlertaRevisionGastos: true})
    }

    renderModalAlerta = () => {
        const { verAlertaRevisionGastos } = this.state;

        return (
            <Modal open={verAlertaRevisionGastos} onClose={() => { this.setState({verAlertaRevisionGastos: false}) }} center>
               < div className="row">
                    <div className={`col-lg-4 col-md-6 col-sm-8 offset-lg-4 offset-md-3 offset-sm-2 text-center`}>
                        <div className="panel-body">
                        <img src={require("../../../../../../assets/img/alertas/notificacion1fcm.png")} alt="Prenda Cŕedito Avanza"/>
                        </div>
                    </div>
                </div>
                <div className="text-center txt">
                    <span className="reset-caption">Periodo con Gastos pendientes de Revisar.</span><br/>

                </div>
            </Modal>
        );
    }

    abrirModalDetallePago = (id, row) => {
        this.setState({openDetallePago: true, transaccion_sel: row}, () => {
            this.props.getDetallePago(row.id);
        });
    }

    renderModalDetallePago = () => {
        const { pagos_recibos, generarPDFReciboCaja } = this.props;
        const { openDetallePago, transaccion_sel } = this.state;

        return (
            <Modal open={openDetallePago} onClose={() => { this.setState({openDetallePago: false}) }} center>
               <div className="mt-3">
                <h2 className="text-left text-primary">Pago No. { transaccion_sel ? transaccion_sel.no_recibo_caja : "" } </h2>
                </div>

                {transaccion_sel && (
                    <div className="row">
                        <div className="my-3 col-lg-6">
                            <div>
                                <span className="m-none t-mostaza semibold">Cliente: </span>
                                <span className="m-none t-musgo semibold">{ transaccion_sel.cliente__nombre }</span>
                            </div>
                            <div>
                                <span className="m-none t-mostaza semibold">Cobrador: </span>
                                <span className="m-none t-musgo semibold">{ transaccion_sel.cobrador_nombre }</span>
                            </div>
                            <div>
                                <span className="m-none t-mostaza semibold">Fecha: </span>
                                <span className="m-none t-musgo semibold"><RenderDateTime fecha={ transaccion_sel.fecha }></RenderDateTime></span>
                            </div>
                            <div>
                                <span className="m-none t-mostaza semibold">Monto: </span>
                                <span className="m-none t-musgo semibold"><RenderMoneda monto={ transaccion_sel.monto } simbolo={'Q. '} /></span>
                            </div>
                            {
                                !transaccion_sel.estado && (
                                    <div>
                                        <span className="m-none t-mostaza semibold">Estado: </span>
                                        <span className="m-none t-musgo semibold">Anulado</span>
                                    </div>
                                )
                            }
                        </div>

                        <div className="col-lg-6 mt-4">
                            <div className="col-md-12 m-0 p-0 d-flex justify-content-end">
                                <img
                                    className="action-img"
                                    alt="Imprimir Recibo Caja"
                                    title="Imprimir Recibo Caja"
                                    src={iconoImprimir}
                                    onClick={() => generarPDFReciboCaja(transaccion_sel.id)}>
                                </img>
                            </div>
                        </div>

                    </div>
                )}

                {(pagos_recibos && pagos_recibos.length > 0) && (
                    <table className="table">
                        <thead>
                            <tr>
                                <th>No. Factura</th>
                                <th>No. Despacho</th>
                                <th>Monto Abonado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pagos_recibos.map(pago => (
                                pago.abonos_relacionados.map(abono => (
                                    <tr key={abono.id}>
                                        <td>
                                            {abono.no_factura_rel && abono.no_factura_rel.length > 0 ? abono.no_factura_rel : (abono.deuda_cliente && abono.deuda_cliente.afectado_origen) ? abono.deuda_cliente.afectado_origen.no_factura : ""}
                                        </td>
                                        <td>
                                            {abono.deuda_cliente && abono.deuda_cliente.afectado_origen ? abono.deuda_cliente.afectado_origen.no_despacho + " " + abono.no_despacho_rel : abono.no_despacho_rel}
                                        </td>
                                        <td>
                                            <RenderMoneda monto={abono.monto_abonado || 0} simbolo={'Q. '} />
                                        </td>
                                    </tr>
                                ))
                            ))}
                        </tbody>
                    </table>
                )}
            </Modal>
        );
    }

    render(){
        let {data, item, loader, entidad, empresas, permisos, page, onSortChangeRefuse, dataHistorialLiquidaciones,
            listarRecibosCaja, data_recivos_caja, changeRangeDateRecibosCaja, changeCliente, changeCobrador, estadoRecibosChange,
            listarHistorialLiquidaciones, changeVendedor, changeTipoLiquidacion, changeRangeDate, changeUsuarioAprobaciones
         } = this.props

        return(
            <CardSimple
                titulo={item? `caja de: ${item.nombre_dueno} ${item.apellido_dueno}`: "n/a" }
                margen={' '}
            >

                {/* MODALS */}
                {this.renderModalAlerta()}
                {this.renderModalDetallePago()}
                <Modal open={this.state.open_modal_retiro} onClose={(e) => {
                        this.setOpenModalRetiro(false)
                    }} center>
                        <div className="">
                            <h2 className="text-center text-primary text-uppercase">Registrar Retiro</h2>
                        </div>
                        <RetiroForm
                            loader={loader}
                            initialValues={{fecha:new Date()}}
                            data={empresas}
                            onSubmit={this.handleSubmitRetiro}
                            setOpenModalRetiro={this.setOpenModalRetiro}
                        />
                </Modal>
                <Modal open={this.state.open_modal} onClose={(e) => {
                        this.setOpenModal(false)
                    }} center>
                        <div className="">
                            <h2 className="text-center text-primary text-uppercase">Registrar transferencia</h2>
                        </div>
                        <EgresoForm
                            boton={this.props.boton}
                            initialValues={{fecha:new Date(), egreso_tipo: 'false'}}
                            data={data}
                            onSubmit={this.handleSubmit}
                            setOpenModal={this.setOpenModal}
                        />
                </Modal>
                <Modal
                    open={this.state.modalHistory}
                    onClose={(e) => {
                        this.setOpenModalHistory(false)
                    }}
                    classNames={{modal: 'modal-xl'}}
                    center
                    >
                        <div className="">
                            <h2 className="text-center text-primary text-uppercase">Historial de movimientos</h2>
                        </div>
                        <EstadoPeriodo
                            {...this.props}
                            data={this.props.periodo}
                            loader={loader}
                        />
                </Modal>
                <Modal open={this.state.open_modal_cierre} onClose={(e) => {
                        this.setOpenModalCierre(false)
                    }} center>
                        <div className="">
                            <h2 className="text-center text-primary text-uppercase">¿Desea cerrar la caja?</h2>
                        </div>
                        <CerrarEstadoPeriodo
                            data={this.props.periodo}
                            loader={loader}
                            cerrarperiodo={this.cerrarperiodo}
                            setOpenModalCierre={this.setOpenModalCierre}
                        />
                </Modal>
                <Modal
                    open={this.state.modalHistorialLiquidaciones}
                    classNames={{modal: 'modal-xl'}}
                    onClose={(e) => {
                        this.setOpenModalHistorilLiquidaciones(false)
                    }}
                    center
                    >
                        <HistorialDetalle
                            {...this.props}
                            data={this.props.periodo}
                            loader={loader}
                        />
                </Modal>
                <Modal
                    open={this.state.openModalReciboDetalle}
                    classNames={{modal: 'modal-xl'}}
                    onClose={(e) => {
                        this.setOpenModalReciboDetalle(false)
                    }}
                    center
                    >
                        {/* <ReciboCajaDetalle
                            recibo_caja={this.props.item_recibo_caja}
                            loader={loader}
                        /> */}
                </Modal>
                <Tabs
                    defaultActiveKey="CAJACHICA"
                    tabBarPosition="top"
                    onChange={this.callback}
                    renderTabBar={() => <ScrollableInkTabBar />}
                    renderTabContent={() => <TabContent />}
                >
                    <TabPane tab="CAJA" key="CAJA">
                        {/* ACTIVDAD RECIENTE DE CAJA CHICA */}
                        <MiCaja
                            {...this.props}
                            data={this.props.estado}
                            item={item}
                            role={this.props.role}
                            loader={loader}
                            entidad={entidad}
                            setOpenModal={this.setOpenModal}
                            setOpenModalRetiro={this.setOpenModalRetiro}
                            setOpenModalCierre = {this.setOpenModalCierre}
                            pendientes={this.props.pendientes}
                            AcceptMovimiento={this.props.AcceptMovimiento}
                            RefuseMovimiento={this.props.RefuseMovimiento}
                            CancelMovimiento={this.props.CancelMovimiento}
                            idcaja={this.props.match.params.id}
                            permisos={permisos}
                            dateStart={this.props.dateStart}
                            dateEnd={this.props.dateEnd}
                            setDateStart={this.props.setDateStart}
                            setDateEnd={this.props.setDateEnd}
                            changeMovimiento={this.props.changeMovimiento}
                            valorMovimiento={this.props.valorMovimiento}
                            total_debe={this.props.total_debe}
                            total_haber={this.props.total_haber}
                        />
                    </TabPane>
                    <TabPane tab="HISTORIAL" key="HISTORIAL">
                        {/* HISTORIAL DE CAJA CHICA */}
                        <HistorialCaja
                            historial={this.props.historial}
                            pagehistorial={this.props.pagehistorial}
                            loader={this.props.loader}
                            HistorialMiCaja={this.props.HistorialMiCaja}
                            caja={this.props.match.params.id}
                            setOpenModalHistory = {this.setOpenModalHistory}
                            abrirModalAlerta={this.abrirModalAlerta}
                        />
                    </TabPane>
                    <TabPane tab="LIQUIDACIONES" key="LIQUIDACIONES">
                        <LiquidacionesGrid
                        id = {item.id}
                        />
                    </TabPane>
                    <TabPane tab="HISTORIAL LIQUIDACIONES" key="HISTORIAL-LIQUIDACIONES">
                        <HistorialLiquidaciones
                            id={item.id}
                            id_user={this.props.id_user}
                            permisos={permisos}
                            data={dataHistorialLiquidaciones}
                            loader={loader}
                            page={page}
                            listar ={listarHistorialLiquidaciones}
                            setOpenModal={this.setOpenModalHistorilLiquidaciones}
                            fecha_I={this.props.fecha_I_historial}
                            fecha_F={this.props.fecha_F_historial}
                            changeRangeDate={changeRangeDate}
                            changeVendedor={changeVendedor}
                            changeUsuarioAprobaciones={changeUsuarioAprobaciones}
                            changeTipoLiquidacion={changeTipoLiquidacion}
                        />
                    </TabPane>
                    <TabPane tab="RECIBOS DE CAJA" key="RECIBOS-CAJA">
                        <RecibosCaja
                            id={item.id}
                            id_user={this.props.id_user}
                            permisos={permisos}
                            data={data_recivos_caja}
                            loader={loader}
                            page={page}
                            listar ={listarRecibosCaja}
                            estado_recibos={this.props.estado_recibos}
                            changeCobrador={changeCobrador}
                            estadoRecibosChange={estadoRecibosChange}
                            setOpenModal={this.setOpenModalReciboDetalle}
                            fecha_I={this.props.fecha_I_recibos}
                            fecha_F={this.props.fecha_F_recibos}
                            changeRangeDate={changeRangeDateRecibosCaja}
                            changeCliente={changeCliente}
                            searchChangeRecibosCaja={this.props.searchChangeRecibosCaja}
                            search_recibos_caja={this.props.search_recibos_caja}
                            abrirModalPago={this.abrirModalDetallePago}
                        />
                    </TabPane>
                </Tabs>
            </CardSimple>
        )
    }
}

export default withRouter(DetalleCaja);
